<template>
  <div class="overflow-y-auto" style="height: calc(100dvh - 152px);">
    <div
      v-for="(participant, index) in session.participants"
      v-if="!loading && session.participants.length"
      :key="`session_participant_bilan_${index}`"
    >
      <div class="d-flex align-center">
        <v-col cols="3">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <div
              class="d-flex align-center"
            >
              {{ getParticipantName(participant) }}
            </div>
          </v-col>
        </v-col>
        <v-col cols="9">
          <v-col cols="12" class="d-flex justify-center align-center">
            <div
              v-if="!participant.presenceMarked"
              class="d-flex align-center"
            >
              <v-btn v-if="canUserPerformAction" x-small class="mx-1" color="info" @click="updatePresence(participant, presenseStatus.PRESENT)">Present</v-btn>
              <v-btn v-if="canUserPerformAction" x-small class="mx-1" color="info" @click="updatePresence(participant, presenseStatus.ABSENT)">Absent</v-btn>
              <v-btn v-if="!participant.presenceMarked && !!participant.presence_status && canUserPerformAction" small class="mx-1" icon color="third" @click="closeEdit(participant)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div v-else-if="canUserPerformAction" class="d-flex align-center">
              <v-btn color="grey" @click="updateParticipantPresence(participant)">
                {{ presenceLabel(participant) }}
              </v-btn>
            </div>
          </v-col>
        </v-col>
      </div>
      <v-divider />
    </div>
    <div v-if="!loading && !session.participants.length" class="full-height d-flex align-center justify-center grey--text">
      Aucun participant
    </div>
    <div v-if="loading" class="d-flex justify-center align-center full-height">
      <Loader />
    </div>
  </div>
</template>

<script>
import { computed, inject, ref, provide, onBeforeMount } from '@vue/composition-api';
import { presenseStatus } from '@/helpers/variables';
import { computeCartItem, sendNotification } from '@/helpers/utils';
import { getCustomerDetail, createCustomerOrder } from '@/helpers/request';

import store from '@/store';

import Loader from '@/components/common/Loader.vue';

export default {
  components: { Loader },
  setup () {
    const authUser = computed(() => store.state.user);
    const session = inject('selectedSession');
    const loading = ref(false);
    const updateSession = inject('updateSession');

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    const getParticipantName = participant => `${participant.firstname} ${participant.lastname}`;

    const presenceLabel = participant => {
      switch (participant.presence_status) {
        case presenseStatus.PRESENT: {
          return 'Présent';
        }
        case presenseStatus.ABSENT: {
          return 'Absent';
        }
        default:
          return null;
      }
    };

    const updateParticipantPresence = participant => {
      const index = session.value.participants.findIndex(p => p.uuid === participant.uuid);

      session.value.participants[index].presenceMarked = false;
    };

    const closeEdit = participant => {
      const index = session.value.participants.findIndex(p => p.uuid === participant.uuid);

      session.value.participants[index].presenceMarked = true;
    };

    const updatePresence = async (participant, status) => {
      const notification = {
        type: 'success',
        text: 'Présence mise à jour avec succès'
      };
      loading.value = true;
      const index = session.value.participants.findIndex(p => p.uuid === participant.uuid);

      if (status === presenseStatus.ABSENT) {
        session.value.participants[index].horse = null;
      }

      session.value.participants[index].presenceMarked = true;

      session.value.participants[index].presence = status === presenseStatus.PRESENT;
      session.value.participants[index].presence_status = status;
      loading.value = false;
      updateSession();
      sendNotification(notification.type, notification.text);
    };

    onBeforeMount(async () => {
      if (!store.state.isLazyLoaded.products) {
        loading.value = true;
        await store.dispatch('getProducts');
        loading.value = false;
      }
    });

    return { canUserPerformAction, authUser, getParticipantName, session, presenceLabel, updateParticipantPresence, presenseStatus, closeEdit, updatePresence, loading };
  }
};
</script>
